<template>
  <v-container class="ts-player-chart">
    <v-row class="ts-player-chart__control" no-gutters>
      <v-col cols="auto">
        <v-switch
            v-model="accumulate"
            label="누적"
        ></v-switch>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-select
            label="Unit"
            v-model="unit" :items="formats" :item-text="(item) => $t(`day-unit.${item.value}`)"
            @change="v => $emit('update:unit-control',v)"
        />
      </v-col>
    </v-row>
    <v-row class="ts-player-chart__chart">
      <ts-line-chart
          :chart-data="chartData"
          :options="chartOptions"
      ></ts-line-chart>
    </v-row>
  </v-container>
</template>


<style lang="scss">
  $control-height: 50px;
  .ts-player-chart{
    position:relative;
    height:100%;
    &__control{
      height: $control-height;
      > .v-select{
        width:100px;
        flex-grow:0;
      }
    }
    &__chart{
      height: calc(100%- #{$control-height})
    }
  }
</style>

<script>
  import TsLineChart from "@/components/chart/TsLineChart";

  export default {
    name: "TsPlayerChart",
    components: {TsLineChart},
    props: {
      players: Array,
      records: Array,
      minTotal: {
        type:Number,
        default: 1
      },
      unitControl:{
        type: String,
        default: 'hour'
      }
    },
    watch: {
      unitControl(val) {this.unit = val}
    },
    data: function () {
      return {
        dataExtractor: (data) => this.accumulate ? data.winRatio : data.deltaWinRatio,

        accumulate: false,
        unit: this.unitControl,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
        },
        formats: [
          {value: 'year', format: this.$day.YEAR_FORMAT},
          {value: 'month', format: this.$day.MONTH_FORMAT},
          {value: 'day', format: this.$day.DATE_FORMAT},
          {value: 'hour', format: this.$day.HOUR_FORMAT},
          /*{value: 'min', format: this.$day.MIN_FORMAT},*/
        ]
      }
    },
    computed: {
      format () {
        const formats = Object.fromEntries(this.formats.map(({value,format})=> ([value,format])))
        return formats[this.unit] || formats.hour
      },
      /* label, color, history 세팅 */
      teamData () {
        return this.records.filter(({total}) => total >= this.minTotal).map((record,teamIdx) => {
          const teamName = record.players.map(p => p.name).join('|');
          let teamColor = [0,0,0]
          const dummy = document.createElement('div')
          document.body.appendChild(dummy)
          record.players.map(p => p.color).forEach((color) => {
            dummy.style.color = color
            const rgbColors = (window.getComputedStyle(dummy).color || 'rgb(0,0,0)').match(/\d+/g)
            teamColor = teamColor.map((rgb,i) => rgb- -rgbColors[i])
          })
          dummy.remove()
          teamColor = teamColor.map(rgb => rgb / record.players.length)

          // data grouping
          let groupData = {}
          record.history.forEach(_hist => {
              const group = this.$day(_hist.date).format(this.format)
              if(!(group in groupData)) groupData[group] = []
              groupData[group].push({
                ..._hist,
                group,
                teamIdx
              })
            })

          const rows = []
          for( const group in groupData){
            const historyList = groupData[group]
            let mergedData = {}
            historyList.forEach(_hist => {
              mergedData = {
                ..._hist,
                winDelta: (mergedData.winDelta || 0)- -_hist.winDelta,
                loseDelta: (mergedData.loseDelta || 0)- -_hist.loseDelta,
              }
            })
            const total = mergedData.winDelta- -mergedData.loseDelta
            mergedData.deltaWinRatio = Math.round(mergedData.winDelta * 1000 / (total || 1)) / 10
            rows.push(mergedData)
          }
          console.log(rows)

          return {
            teamName,
            teamColor: `rgb(${teamColor.join(',')})`,
            rows
          }
        })
      },
      chartData () {
        const groupedData = {}
        const datasets = this.teamData.map((teamDat) => {
          teamDat.rows.forEach(_history => {
            if (!(_history.group in groupedData)) groupedData[_history.group] = []
            groupedData[_history.group].push(_history)
          })
          return {
            data: [],
            label: teamDat.teamName,
            fill: false,
            borderWidth: 3,
            spanGaps: true,
            borderColor: teamDat.teamColor,
            backgroundColor: teamDat.teamColor,
          }
        })

        // 데이터 뻥튀기와 라벨 설정
        const labels = Object.keys(groupedData).sort((a,b) => a.localeCompare(b))
        labels.forEach(label => {
          const pushedTeamIdx = []
          groupedData[label].forEach(data => {
            datasets[data.teamIdx].data.push(this.dataExtractor(data))
            pushedTeamIdx.push(data.teamIdx)
          })
          datasets.filter((ds,i) => !pushedTeamIdx.includes(i)).forEach(dataset => {
            dataset.data.push(null)
          })
        })

        // 마지막 데이터가 없는 DataSet 채워주기
        datasets.forEach(dataset => {
          if( dataset.data.slice(-1)[0] === null ){
            dataset.data.splice(-1,1,dataset.data.filter(item => item !== null).slice(-1)[0])
          }
        })


        return {
          labels,
          datasets
        }
      }
    },
    methods: {
    }
  }
</script>